import { useState, useEffect, useCallback } from 'react'

export default function useFormState(isOpen: boolean) {
  const [{ error, loading }, setFormState] = useState<{
    loading: boolean
    error: Error | null
  }>({ loading: false, error: null })

  // reset state on dialog close
  useEffect(() => {
    !isOpen && setFormState({ loading: false, error: null })
  }, [isOpen])

  const onSubmit = useCallback(() => {
    setFormState({ loading: true, error: null })
  }, [])

  const onError = useCallback((error: Error) => {
    setFormState({ loading: false, error })
  }, [])

  return {
    error,
    loading,
    onSubmit,
    onError,
  }
}
